/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tenantsListApiKeys } from "../../funcs/tenantsListApiKeys.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$inboundSchema,
};

export const tool$tenantsListApiKeys: ToolDefinition<typeof args> = {
  name: "tenants_list-api-keys",
  description: `List tenant API keys

Retrieves all API keys for a specific tenant`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsListApiKeys(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
